import React from 'react';
import { SERVER_URL } from '../constants';
import { durations, purcentages, times } from '../constants/trade';
import toast from 'react-hot-toast';
import { useUserStore } from '../models/';
import { create } from 'zustand';

const useTrade = (coins, coin, setCoin) => {
  const route = '/trade';
  const [loading, setLoading] = React.useState(false);

  const [activeButton, setActiveButton] = React.useState('buy');
  const [coinSelector, setCoinSelector] = React.useState(false);
  const [timer, setTimer] = React.useState({
    time: '30s',
    rate: '10%',
    min: 100,
  });
  const [max, setMax] = React.useState(0);
  const [selector, setSelector] = React.useState(
    `${coin?.symbol} - $${coin?.price?.toFixed(2)}`,
  );

  React.useEffect(() => {
    setCoin(coins[0]);
  }, [coins]);
  React.useEffect(() => {
    setSelector(`${coin?.symbol} - $${coin?.price?.toFixed(2)}`);
  }, [coin]);

  const [result, setResult] = React.useState(null);

  return {
    loading,
    activeButton,
    setActiveButton,
    coinSelector,
    setCoinSelector,
    timer,
    setTimer,
    max,
    setMax,
    selector,
    times,
    result,
  };
};

const route = '/trade';

export const useTradeHistory = create((set, get) => ({
  result: [],
  setResult: (result) => set({ result }),
  loading: false,
  isOpenModal: false,
  tradeIdInModal: null,
  getTradeInModal: () => {
    const tradeId = get().tradeIdInModal;
    return get().result.find(trade => trade._id === tradeId); 
  },
  closeModal: () => set({ isOpenModal: false, tradeIdInModal: null }),
  setLoading: (loading) => set({ loading }),
  getTrade: async (id) => {
    set({ loading: true });
    const response = await fetch(`${SERVER_URL}${route}/${id}`, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') || '',
      },
    });
    const data = await response.json();

    set({ result: data });
    set({ loading: false });
  },
  getAwaitedTrade: async (id) => {
    const response = await fetch(`${SERVER_URL}${route}/awaited/${id}`, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') || '',
      },
    });
    const data = await response.json();

    if (response.ok) {
      set((state) => {
        return {
          result: state.result.map((r) => {
            if (r._id === data.transaction._id) {
              return data.transaction;
            }
            return r;
          }),
        }
      });

      const unsub1 = useUserStore.subscribe(console.log);
      // Updating state, will trigger listeners
      useUserStore.setState({ user: data.user });
      // Unsubscribe listeners
      unsub1();
    }
  },
  addTrade: async (userId, tradeInfo) => {
    const body = {
      userId,
      duration: tradeInfo.duration,
      coinId: tradeInfo.coin,
      type: tradeInfo.type,
      amount: Number(tradeInfo.amount),
    };

    try {
      const response = await fetch(`${SERVER_URL}${route}`, {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') || '',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });
      const data = await response.json();

      if (response.ok) {
        set((state) => ({ result: [data.transaction, ...state.result], isOpenModal: true, tradeIdInModal: data.transaction._id }));
        toast.success('Trade created successfully');

        const unsub1 = useUserStore.subscribe(console.log);
        // Updating state, will trigger listeners
        useUserStore.setState({ user: data.user });
        // Unsubscribe listeners
        unsub1();
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      console.log(err);
    }
  },
  deleteTrade: async (id) => {
    set({ loading: true });
    const response = await fetch(`${SERVER_URL}${route}/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') || '',
      },
    });
    const data = await response.json();
    set({ result: data.filter((r) => r.id !== id) });
    set({ loading: false });
  },
  updateManyTrades: async (coinId) => {
    set({ loading: true });
    const response = await fetch(`${SERVER_URL}${route}/updateMany`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token') || '',
      },
      body: JSON.stringify({ coinId }),
    });
    const data = await response.json();
    set({ loading: false });
  },
}));

export default useTrade;
